import { render, staticRenderFns } from "./VuesticTreeRoot.vue?vue&type=template&id=0fa98b50&"
import script from "./VuesticTreeRoot.vue?vue&type=script&lang=js&"
export * from "./VuesticTreeRoot.vue?vue&type=script&lang=js&"
import style0 from "./VuesticTreeRoot.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "VuesticTreeRoot.vue"
export default component.exports